import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Chip,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";

import { useNavigate } from "react-router-dom";
import usePrivilegeCheck from "../../../constants/customHooks/UsePrivilegeCheck.js";
import PremissionDialog from "../../customComponent/premissionDialog.js";
import LeadPassportEditApprove from "./LeadsPassportEditApprove.js";
import LeadPassportVerify from "./leadPassportVerify.js";
import { checkPassportSubMenuPrivillage, checkSubMenuPrivillage } from "../../../actions/subMenuPrivillageAction.js";
import { useDispatch, useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  formControl: {
    marginBottom: theme.spacing(2),
    marginTop: "8px",
  },
  hoverElement: {
    "&:hover": {
      color: "#FE0B7A", // Set the hover color
    },
    "&.clicked": {
      backgroundColor: "#FE0B7A",
      color: "white",
    },
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
  },
  searchInput: {
    marginLeft: theme.spacing(1),
  },
}));

function LeadPassportApprovals(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const { privilege, hasPrivilege, isCreatePrevilage } = usePrivilegeCheck();

  const classes = useStyles();
  // const [clicked, setClicked] = useState("passportverify");
  const [addFormCountry, setAddFormCountry] = useState(false);
  const [addFormState, setAddFormState] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [clicked, setClicked] = useState("");
  const [filteredChips, setFilteredChips] = useState([]);    

  // HandleClose dialog

  const { checkEmployeePrivilegeSuccess } = useSelector(
    (state) => state.checkEmployeePrivilege
  );

  let { loginFindLoading, loginFindSuccess, loginFinderror } = useSelector(
    (state) => {
      return state.findUser;
    }
  );

  const { passportSubmenuSuccess } = useSelector((state) => state.passportSubmenuPrivillage)

  useEffect(() => {
    if (loginFindSuccess?.fk_role_id == "admin") {
      dispatch(checkPassportSubMenuPrivillage("admin"))
    } else {
      let roleId = [...new Set(checkEmployeePrivilegeSuccess?.data?.role_sub_menus.map((value) =>
        value?.roleId))].join("");
        
      dispatch(checkPassportSubMenuPrivillage(roleId))
    }
  }, [])

  const handleCloseDialog = () => {
    setOpenAlert(false);
  };

  const handleClick = (master) => {
    setClicked(master);
  };

  const handleModalClick = () => {
    if (clicked === "Categories") {
      setAddFormCountry(true);
    }

    if (clicked === "Topics") {
      setAddFormState(true);
    }
  };

  const chipData = [
    { key: "passportverify", label: "Lead passport verify approval" },
    { key: "passportedit", label: "Lead passport edit approval" },
  ];

  useEffect(() => {
      if (passportSubmenuSuccess?.data) {
        const filtered = chipData.filter(chip =>
          passportSubmenuSuccess?.data.includes(chip.label)
        );
        setFilteredChips(filtered);
        setClicked(filtered[0]?.key)
      }
    }, [passportSubmenuSuccess]);

  //   const searchHandleChange = (value) => {
  //     setSearchValue(value);
  //   };

  // if (!hasPrivilege("Approval Request") && privilege !== null) {
  //   return (
  //     <Alert severity="error">
  //       <AlertTitle>warning</AlertTitle>
  //       You don't have permission to access — <strong>this page.!</strong>
  //     </Alert>
  //   );
  // }

  if(filteredChips.length === 0) {
    return (
      <Alert severity="error">
      <AlertTitle>warning</AlertTitle>
      You don't have permission to access — <strong>this page.!</strong>
    </Alert>
    )
  }
  return (
    <>
        <Grid item xs={12} lg={6} mt={2}>
        {filteredChips.map((chip) => (
          <Chip
            className={`${classes.hoverElement} ${
              clicked === chip.key ? "clicked" : ""
            }`}
            label={chip.label}
            component="a"
            clickable
            sx={{ m: 0.3 }}
            onClick={() => handleClick(chip.key)}
          />
        ))}
        </Grid>

      {clicked === "passportverify" && <LeadPassportVerify submenu="leadPassportApproval" />}
      {clicked === "passportedit" && <LeadPassportEditApprove submenu="leadPassportEditApproval" />}

      {openAlert && (
        <PremissionDialog
          openAlert={openAlert}
          handleClose={handleCloseDialog}
        />
      )}
    </>
  );
}

export default LeadPassportApprovals;
